// extracted by mini-css-extract-plugin
module.exports = {"color-white":"_29H5Z","colorWhite":"_29H5Z","color-gray90":"epZ2s","colorGray90":"epZ2s","color-red":"_1hTF4","colorRed":"_1hTF4"};